import { render, staticRenderFns } from "./TicketWidget.vue?vue&type=template&id=63ed54fa"
import script from "./TicketWidget.vue?vue&type=script&lang=js"
export * from "./TicketWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports